import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAccessLegacyDetails,
  getAuthorityListAPI,
  getFinalAccessLegacyDetails,
  getPAList,
  getROList,
  getRowLegacyDetails,
  submitAccessLegacyDetails,
  submitFinalAccessLegacyDetails,
  submitRowLegacyDetails,
  updateAcessLegacyDetails,
  updateFinalAcessLegacyDetails,
  updateRowLegacyDetails,
  authorityList,
  roListSelection,
  piuListSelection,
  getLegacyTransactionDetails,
  updateLegacyPaymentDetails,
  getLegacySubStages,
} from "../services/apiEndpoints";

export const fetchAccessLegacyDetailsThunk = createAsyncThunk(
  "/legacy-details",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await getAccessLegacyDetails(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchFinalAccessLegacyDetailsThunk = createAsyncThunk(
  "/legacy-details",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await getFinalAccessLegacyDetails(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchRowLegacyDetailsThunk = createAsyncThunk(
  "/legacy-details-row",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await getRowLegacyDetails(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateLegacyAccessApplicationThunk = createAsyncThunk(
  "/legacy/update",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await updateAcessLegacyDetails(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateFinalLegacyAccessApplicationThunk = createAsyncThunk(
  "/final/legacy/update",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await updateFinalAcessLegacyDetails(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateLegacyRowApplicationThunk = createAsyncThunk(
  "/legacy/update-row",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await updateRowLegacyDetails(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const submitLegacyAccessApplicationThunk = createAsyncThunk(
  "/legacy/submit",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await submitAccessLegacyDetails(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const submitFinalLegacyAccessApplicationThunk = createAsyncThunk(
  "/final/legacy/submit",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await submitFinalAccessLegacyDetails(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getAuthorityListThunk = createAsyncThunk<any, void>(
  "/authorities",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAuthorityListAPI();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getROListThunk = createAsyncThunk(
  "/authorities/ro",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await getROList(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getPAListThunk = createAsyncThunk(
  "/authorities/pa",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await getPAList(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const submitLegacyRowApplicationThunk = createAsyncThunk(
  "/legacy/submit-row",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await submitRowLegacyDetails(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// export const getAuthorityListThunk = createAsyncThunk(
//   "/legacy/authorities",
//   async (_: any, { rejectWithValue }) => {
//     try {
//       const response = await authorityList();
//       return response.data;
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   },
// );

export const getRoListSelectionThunk = createAsyncThunk(
  "/legacy/authorities/ro",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await roListSelection(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getPiuListSelectionThunk = createAsyncThunk(
  "/legacy/authorities/piu",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await piuListSelection(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchLegacyTransactionDetailsThunk = createAsyncThunk(
  "/payment/legacy-transaction-detail",
  async (legacyApplicationId: any, { rejectWithValue }) => {
    try {
      const response = await getLegacyTransactionDetails(legacyApplicationId);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const updateLegacyPaymentDetailsThunk = createAsyncThunk(
  "/payment/update-payment-details",
  async (
    payload: { payload: any; },
    { rejectWithValue },
  ) => {
    try {
      const response = await updateLegacyPaymentDetails(
        payload.payload,
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// export const fetchLegacySubStagesThunk = createAsyncThunk(
//   "/legacy/sub-stages",
//   async (_: void, { rejectWithValue }) => {
//     try {
//       const response = await getLegacySubStages();
//       return response.data;
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   },
// );

export const fetchLegacySubStagesThunk = createAsyncThunk<any, void>(
  "/legacy/sub-stages",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getLegacySubStages();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

